import * as React from 'react';
import { FilterOptionModel } from './filter-types';
import { ClickTracker } from 'bernie-analytics';
import { UitkCheckbox } from 'uitk-react-switch';

export interface CheckboxInputProps extends FilterOptionModel {
  index?: number;
  checked?: boolean;
  handleClick?: (Event) => void;
  handleChange?: (Event) => void;
  firstIndex?: number;
  lastIndex?: number;
  description?: string;
  isRange?: boolean;
  filterCategory?: string;
}

const CheckboxTracked = ClickTracker(UitkCheckbox);

export class CheckboxInput extends React.Component<CheckboxInputProps> {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(event) {
    const { handleChange, name, value, filterCategory } = this.props;
    const target = event.target;
    const { checked } = target;
    if (typeof handleChange === 'function') {
      handleChange({
        target: {
          name,
          value,
          checked,
          filterCategory
        }
      });
    }
  }

  public render() {
    const {
      checked,
      index,
      label,
      description,
      name,
      value,
      firstIndex,
      lastIndex,
      isRange,
      count,
      filterCategory,
      ariaLabel
    } = this.props;
    const oneBasedIndex = index + 1;
    const checkboxAttributes = {
      id: `${name}-${index}-${value}`,
      key: `${name}-${index}-${value}`,
      name,
      value,
      checked,
      onChange: this.handleChange,
      label: typeof count === 'number' ? `${label} (${count})` : label, // Exp 28369: PWA_show_count_of_properties_on_filter_selection
      description,
      disabled: false
    };

    if (isRange && index > firstIndex && index < lastIndex) {
      checkboxAttributes.disabled = true;
      checkboxAttributes.checked = true;
    }

    const categoryStr = `${filterCategory ? '.' + filterCategory : ''}`;

    return (
      <CheckboxTracked
        events="click"
        aria-label={ariaLabel}
        key={checkboxAttributes.id}
        linkName={`${name}.${value}`}
        rfrr={`${name}${categoryStr}.${value}.${!checked}:${oneBasedIndex}`}
        {...checkboxAttributes}
      />
    );
  }
}
